"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var scrollbar_wrapper_scss_1 = tslib_1.__importDefault(require("./scrollbar-wrapper.scss"));
var ScrollbarWrapper = function (_a) {
    var className = _a.className, dataHook = _a.dataHook, children = _a.children;
    return (react_1.default.createElement("div", { "data-hook": dataHook, className: (0, classnames_1.default)(scrollbar_wrapper_scss_1.default['scrollbar-wrapper'], className) }, children));
};
exports.default = ScrollbarWrapper;
//# sourceMappingURL=scrollbar-wrapper.js.map